import { Component, Output, EventEmitter, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import moment from 'moment';

export interface SortConfig {
    label: string;
    value: string;
    sortBy: string;
    sortOrder: 'asc' | 'desc';
}

@Component({
    selector: 'app-search-and-filter',
    templateUrl: './search-and-filter.component.html',
    styleUrls: ['./search-and-filter.component.scss'],
})
export class SearchAndFilterComponent {
    public maxDate = moment().utc();
    public searchValue: string;
    public selectedSort = 'createdDate_desc';

    public sortOptions: SortConfig[] = [
        {
            label: 'OVERVIEW.TABLE.COLUMN.CREATED_AT',
            value: 'createdDate_desc',
            sortBy: 'createdDate',
            sortOrder: 'desc',
        },
        {
            label: 'OVERVIEW.TABLE.COLUMN.CREATED_AT',
            value: 'createdDate_asc',
            sortBy: 'createdDate',
            sortOrder: 'asc',
        },
        {
            label: 'OVERVIEW.TABLE.COLUMN.NAME',
            value: 'title_asc',
            sortBy: 'title',
            sortOrder: 'asc',
        },
        {
            label: 'OVERVIEW.TABLE.COLUMN.NAME',
            value: 'title_desc',
            sortBy: 'title',
            sortOrder: 'desc',
        },
        {
            label: 'OVERVIEW.TABLE.COLUMN.TOTAL_GROSS',
            value: 'totalGross_desc',
            sortBy: 'totalGross',
            sortOrder: 'desc',
        },
        {
            label: 'OVERVIEW.TABLE.COLUMN.TOTAL_GROSS',
            value: 'totalGross_asc',
            sortBy: 'totalGross',
            sortOrder: 'asc',
        },
    ];

    range = new FormGroup<{ start: FormControl<Date>; end: FormControl<Date> }>({
        start: new FormControl<Date>(null),
        end: new FormControl<Date>(null),
    });

    @Input() public selectedTab: string;

    @Output()
    public offerSearch = new EventEmitter<any>();

    constructor() {}

    resetDate() {
        this.range.controls.start.setValue(null);
        this.range.controls.end.setValue(null);
        this.triggerSearch();
    }

    resetSearch() {
        this.searchValue = '';
        this.triggerSearch();
    }

    triggerDate() {
        if (this.range.controls.start.value && this.range.controls.end.value) {
            this.triggerSearch();
        } else {
            return;
        }
    }

    public onSortSelectionChange(value: string): void {
        this.selectedSort = value;
        this.triggerSearch();
    }

    public triggerSearch() {
        const [sortBy, sortOrder] = this.selectedSort.split('_');
        const start = this.range.controls.start.value;
        const end = this.range.controls.end.value;

        const toDate = end || new Date();
        const toDatePlus1 = moment(toDate).add(1, 'days').startOf('day').toDate();

        const arg = {
            fromDate: start ? new Date(start) : null,
            toDate: toDatePlus1,
            search: this.searchValue,
            sortBy,
            sortOrder,
        };

        this.offerSearch.emit(arg);
    }
}
